// import React, { useState, useEffect } from 'react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useAuth } from '../../helpers/authContext';
import { useParams, useNavigate, Link } from "react-router-dom";   
import { fetchUser } from './userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setSteemConfig } from 'config';
import { RootState } from 'app/store/rootReducer';
import { author_posts, get_plans, get_views } from 'services/db-service';
import PostVideoItem from 'features/posts/postVideoItem';
import AdSense from 'components/AdSense';
import { getPosts, processPosts } from 'services/posts-service';
import FollowButton from 'components/FollowButton';
import { getReputation, numberWithCommas } from 'services/dsteem-service';
import { SEO } from 'components/SEO'; 
import { VerifiedIcon } from 'components/VerifiedIcon';
import { useToast } from 'components/ui/use-toast'; 
import { Row } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';

export const UserProfile  = (params:any) => { 
    const { toast } = useToast();
    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const { username } = useParams(); 
    const { user, rpc_node, updateUserMetadata  } = useAuth();
    const [playlists, setPlaylists] = useState([]);
    const [activeTab, setActiveTab] = React.useState(params.tab || 'videos'); 
    useEffect(() => {
        if (params.tab && params.tab !== activeTab) {
            setActiveTab(params.tab);
        }
    }, [params.tab]);
    const [friendsTab, setFriendsTab] = React.useState('following'); 
    const [currentPosts, setCurrentPosts] = useState([]); 
    const [limit] = useState(30);
    const [friendsPage, setFriendsPage] = useState(1);
    const [communitiesPage, setcommunitiesPage] = useState(1);
    const [playlistsPage, setPlaylistsPage] = useState(1);
    const FRIENDS_PER_PAGE = 200;
    const COMMUNITIES_PER_PAGE = 20; 
    const PLAYLISTS_PER_PAGE = 20; 
    const [startFrom, setStartFrom] = useState(0); 
    const [loadingMore, setLoadingMore] = useState(false); 
    const [profileData, setProfileData] = useState<{name?: string, about?: string, avatar?: string, cover?: string}>({});
    const [hasMore, setHasMore] = useState(false); 
    const [loadingPosts, setLoadingPosts] = useState(false);
    const [filter, setFilter] = useState(params.tab || "videos");  
    const [videosSort, setVideosSort] = useState("recent");  
    const [lastAuthor, setLastAuthor] = useState("");  
    const [lastPermlink, setLastPermlink] = useState("");  
    const [views, setViews] = useState([]); 
    const observer = useRef<IntersectionObserver | null>(null); 
    const {
        userData, 
        isLoading,
        error
    } = useSelector((state: RootState) => state.userData);
    const [userPlans, setUserPlans] = useState([]);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const onNewError = (message) => {
        setErrorMessage(message); 
        setTimeout(() => { setErrorMessage(null); }, 15000);
    } 
    // Scroll feature

    const loadMorePosts = useCallback(async () => { 
        if (!hasMore || currentPosts.length === 0) return;
      
        setLoadingMore(true); 
        try {
            if (activeTab == "videos") {
                console.log("loading more from the db", startFrom);
                let video_posts = [];
                try {
                    video_posts = (await author_posts(username, limit, startFrom, videosSort)) || []; 
                } catch (error) {
                    console.log(error);
                } 
                if (video_posts != undefined && video_posts.length > 0) {
                    video_posts = processPosts(video_posts); 
                    const newPosts = video_posts.filter(newPost =>
                        !currentPosts.some(existingPost =>
                        existingPost.author === newPost.author && existingPost.permlink === newPost.permlink
                        )
                    );
                
                    const updatedPosts = [...currentPosts, ...newPosts];
                    setCurrentPosts(updatedPosts || []);
                    let hasMore = false;
                    if (video_posts.length >= limit) {
                        hasMore = true;
                        setStartFrom(updatedPosts.length);
                    } 
                    setHasMore(hasMore); 
                } 
            }else {
                const newPostsData = await getPosts(limit, username, filter, false, lastAuthor, lastPermlink, "get_account_posts", false); 
            
                const newPosts = newPostsData.posts.filter(newPost =>
                    !currentPosts.some(existingPost =>
                    existingPost.author === newPost.author && existingPost.permlink === newPost.permlink
                    )
                );
            
                const updatedPosts = [...currentPosts, ...newPosts];
                const hasMoreNew = newPostsData.hasMore;
        
                setCurrentPosts(updatedPosts);
                setLastAuthor(newPostsData.lastAuthor);
                setLastPermlink(newPostsData.lastPermlink);
                setHasMore(hasMoreNew);
            }
            
      
        } catch (err) {
            console.log('error getting', err); 
            toast({
                title: "Error",
                description: err,
                variant:"rose_red"
            }); 
        }
      
        setLoadingMore(false);
    }, [dispatch,filter, limit, currentPosts, hasMore, username]);
    useEffect(() => {
        if (userData && userData.posting_json_metadata) {
        try {
            const metadata = JSON.parse(userData.posting_json_metadata);
            const profile = metadata.profile || {}; 
            let it = {
            name: (profile.name || "") + ` (@${username})` || username,
            about: profile.about || `Profile of ${username} on Speak on Steem`,
            avatar: profile.avatar || `https://steemitimages.com/u/${username}/avatar`,
            cover: profile.cover_image || ""
            }
            setProfileData(it); 
            
        } catch (e) {
            console.log("Error parsing profile metadata", e);
            setProfileData({
            name: username,
            about: `Profile of ${username} on Speak on Steem`,
            avatar: `https://steemitimages.com/u/${username}/avatar`,
            cover: ""
            });
        }
        } else {
            setProfileData({
                name: username,
                about: `Profile of ${username} on Speak on Steem`,
                avatar: `https://steemitimages.com/u/${username}/avatar`,
                cover: ""
            });
        }
    }, [userData, username]);
    const lastPostElementRef = useCallback((node) => {  
        if (loadingMore) { return; } 
        if (observer.current) {  
          observer.current.disconnect();
        }
        observer.current = new IntersectionObserver(entries => { 
          if (entries[0].isIntersecting && hasMore) {
            console.log('last element visible, loading more...'); 
            loadMorePosts();
          }
        }, { 
          threshold: 0.1 
        });
        if (node) observer.current.observe(node);
    }, [loadingMore, hasMore, loadMorePosts]); 

    useEffect(() => { 
        setSteemConfig(rpc_node);
        dispatch(fetchUser(username));  
    }, [dispatch, username]); 
    useEffect(() => {
        const getViews = async () => { 
          let data = await get_views();
          setViews(data); 
        }
        getViews(); 
        const getPlans = async () => { 
            let data = await get_plans(); 
            setUserPlans(data); 
        }
        getPlans(); 
    }, [username]);
    useEffect(() => {
        setFriendsPage(1); 
    }, [friendsTab]);

        useEffect(() => {
        const fetchData = async () => { 
            setLoadingPosts(true);
            setCurrentPosts([]);
            let path = activeTab === "videos" ? `/u/${username}` : `/u/${activeTab}/${username}`;
            navigate(path, { replace: true }); 
            try {
                switch (activeTab) {
                    case "videos":
                        // Handled by the specific useEffect for videosSort and activeTab below
                        break;
                    case "blog":
                        console.log("fetching blog");
                        setFilter("posts");
                        let posts = await getPosts(limit,username,"posts",true,"","","get_account_posts", false); 
                         
                        setHasMore(posts.hasMore);
                        setLastAuthor(posts.lastAuthor);
                        setLastPermlink(posts.lastPermlink);
                        setCurrentPosts(posts.posts || []); 
                        break;
                    case "shared":
                        console.log("fetching shared");
                        setFilter("blog");
                        let blog_posts = await getPosts(limit,username,"blog",true,"","","get_account_posts", false);  
                        setHasMore(blog_posts.hasMore);
                        setLastAuthor(blog_posts.lastAuthor);
                        setLastPermlink(blog_posts.lastPermlink);
                        setCurrentPosts(blog_posts.posts || []); 
                        break;
                    case "comments":
                        console.log("fetching comments");
                        setFilter("comments");
                        let comments_posts = await getPosts(limit,username,"comments",true,"","","get_account_posts", false);  
                        setHasMore(comments_posts.hasMore);
                        setLastAuthor(comments_posts.lastAuthor);
                        setLastPermlink(comments_posts.lastPermlink);
                        setCurrentPosts(comments_posts.posts || []); 
                        break;
                    case "friends":
                        console.log("Building friends"); 
                        break;
                    case "communities":
                        console.log("Building communities"); 
                        break;
                    case "playlists":
                        console.log("Building playlists"); 
                        updateUserMetadata();
                        break;
                    default:
                        break;
                }
            } finally {
                setLoadingPosts(false);
            }
        };

        fetchData();
    }, [activeTab, username]); 
    useEffect(()=> {
        let d = null;
        try {
            d = (JSON.parse(userData.json_metadata)?.playlists); 
        } catch (error) {
            console.log("While getting profile", error); 
        } 
        setPlaylists(d || []);
    },[userData]);
    useEffect(() => { 
        const fetchData = async () => {  
            if (activeTab !== "videos") return;
            setLoadingPosts(true);
            setCurrentPosts([]);
            setStartFrom(0);
            console.log("fetching videos...");
            setFilter("videos");
            let video_posts = [];
            try {
                video_posts = (await author_posts(username, limit,0, videosSort)) || []; 
            } catch (error) { 
                console.log(error); 
            } finally {
                setLoadingPosts(false);
            }
            if (video_posts != undefined && video_posts.length > 0) {
                video_posts = processPosts(video_posts); 
                setCurrentPosts(video_posts || []);
                let hasMore = false;
                if (video_posts.length >= limit) {
                    hasMore = true;
                    setStartFrom(limit);
                } 
                setHasMore(hasMore); 
            }  
        };

        fetchData();
    }, [videosSort, activeTab]); 
    let profileHeader; 
    let userCover;
    let following;
    let followers;
    let communities;
    if (!isLoading && userData && Object.keys(userData).length > 0) {   
        let profile = null;
        try {
            profile = (JSON.parse(userData.posting_json_metadata).profile); 
        } catch (error) {
            console.log("While getting profile", error); 
        } 
        following = userData.following_list; 
        followers = userData.followers_list; 
        communities = userData.communities; 
        if (profile && profile.cover_image) {
            userCover = ( 
                <div className="cover-container" style={{ width: "100%", height: "220px", overflow: "hidden" }}>
                    <img src={profile.cover_image} alt='Cover' className='profile-cover' />
                    <div className="profile-cover-gradient"></div>
                    <div className="profile-floating-buttons">
                        {user && user !== username && (
                            <FollowButton author={username} className='mr-2' onError={onNewError} />
                        )} 
                        {user && user == username && (
                            <React.Fragment>
                            <button className="btn btn-default mr-2" onClick={()=>{
                                navigate("/settings")
                            }}>
                                <i className="fas fa-cog" />
                            </button>
                            <button className="btn btn-default mr-2" onClick={()=>{ navigate(`/wallet/${username}`) }}>
                                <i className="fas fa-wallet" />
                            </button>
                            </React.Fragment>
                        )}
                        
                        {/* <button className="btn btn-default">
                            <i className="fas fa-share" />
                        </button> */}
                    </div> 
                </div> 
            );
        } else { 
            userCover = (
                <div className="cover-container" style={{ width: "100%", height: "220px", overflow: "hidden"}}>
                    {/* <img src={profile.cover_image} alt='Cover' className='profile-cover' /> */}
                    {/* <div className="profile-cover-gradient"></div> */}
                    <div className="profile-floating-buttons">
                        {user && user !== username && (
                            <FollowButton author={username} className='mr-2' onError={onNewError} />
                        )} 
                        {user && user == username && (
                            <React.Fragment>
                                <button className="btn btn-default mr-2" onClick={()=>{
                                    navigate("/settings")
                                }}>
                                    <i className="fas fa-cog" />
                                </button>
                                <button className="btn btn-default mr-2" onClick={()=>{ navigate(`/wallet/${username}`) }}>
                                    <i className="fas fa-wallet" />
                                </button>
                            </React.Fragment>
                        )}
                        {/* <button className="btn btn-default">
                            <i className="fas fa-share" />
                        </button> */}
                    </div> 
                </div> 
            );
        }
        const plan = userPlans.find(u => u.username === username);  
        let isPlus = plan?.plan_type?.includes("plus") || false;
        profileHeader = (
            <> 
            <div className="row profile-container d-flex p-2"> 
                <div className="col-12 col-sm-12 col-md-3 col-lg-auto text-center text-sm-center text-md-left">
                    <div className="profile-image-container">
                        <img
                            src={`https://steemitimages.com/u/${username}/avatar`}
                            alt="Profile"
                            className="profile-image"
                            style={{aspectRatio:"1 / 1"}}
                        />
                    </div> 
                </div> 

                <div className="col-12 col-sm-12 col-md-9  col-lg-auto text-center text-sm-center text-md-left"> 
                    <div className="d-inline-block">
                        <div className="d-flex">
                            <h3 className={`fw-bold me-3 m-0 ${(userCover)?"color-md-white":""}`}>{(profile && profile.name)?profile.name:username} ({getReputation(userData.reputation)}) {(isPlus) && (<div className="text-muted d-inline-block"  title='Verified Plus member.' style={{marginRight:"2px", cursor:"pointer"}}><VerifiedIcon size={30} className="color-speem" /> </div> )} <div className="profile-name text-muted">{(profile && profile.name)?`· ${username}`: ""}</div></h3>  
                        </div>  
                    </div>
                    <div className="mb-4 fw-semibold">
                        <span className="cursor-pointer" onClick={() => {setActiveTab("friends"); setFriendsTab("following")}}><strong className={`${(userCover)?"color-md-white":""}`}>{numberWithCommas(userData.followers_count.following_count)}</strong> <span className="text-muted">Following</span></span>
                        <span className="cursor-pointer ml-2" onClick={() => {setActiveTab("friends"); setFriendsTab("followers")}}><strong className={`${(userCover)?"color-md-white":""}`}>{numberWithCommas(userData.followers_count.follower_count)}</strong> <span className="text-muted">Followers</span></span>
                        <span className="cursor-pointer ml-2"><strong className={`${(userCover)?"color-md-white":""}`}>{numberWithCommas(userData.views_count.views || 0)}</strong> <span className="text-muted">Views</span></span>
                    </div> 
                    <div className="following-list mb-2" onClick={() => setActiveTab("friends")}>
                        {following.slice(0, 10).map((f,i) => (
                            <img key={i} src={`https://steemitimages.com/u/${f.following}/avatar`} className='following-user-img' /> 
                        ))}
                        {following.length > 10 && <img key="11" src={`/assets/img/more.jpeg`} className='following-user-img' />}
                    </div>
                    <div className="profile-about text-muted mb-1">{(profile && profile.about)?profile.about:""}</div>
                    {(profile && profile.website) && (
                        <a href={profile.website} className="color-orange" target="_blank" rel="noreferrer">
                            <i className="fas fa-link" /> {profile.website}
                        </a> 
                    )}
                    
                </div> 

            </div> 
            </>
        );
    }
    const renderPosts = () => {
        if (loadingPosts) {
            return (
                <div className="row w-100 m-0">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
                        <div key={i} className="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-2">
                            <div className="card item-speem" style={{border: "none"}}>
                                <Skeleton height={180} className="mb-2" />
                                <div className="p-2">
                                    <div className="d-flex align-items-center mb-2">
                                        <Skeleton circle={true} height={35} width={35} className="mr-2" />
                                        <Skeleton width="60%" height={15} />
                                    </div>
                                    <Skeleton width="90%" height={20} className="mb-1" />
                                    <Skeleton width="40%" height={12} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        if(currentPosts.length == 0){ 
            return (
                <div className='text-center w-100'><strong>No posts yet.</strong></div>
            )
        }
        let section = currentPosts.map((post, index) => { 
            const postUrl = `/@${post.author}/${post.permlink}`;
            const view = views.find(v => v.url === postUrl);
            const viewsCount = view ? view.count : 0; 
            const plan = userPlans.find(u => u.username === post.author);  
            let isPlus = plan?.plan_type?.includes("plus") || false;
            let postData = {
                ...post, 
                views:viewsCount
            }; 
            return (
                <React.Fragment key={`${post.id}-${index}`}>
                    {/* Inject Ad every 8 posts */}
                    {(index > 0 && index % 8 === 0) && (
                        <AdSense type="card" key={`ad-${index}`} />
                    )}
                    <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-2"
                        ref={(node) => {
                            if (index === currentPosts.length - 1) {
                                lastPostElementRef(node);
                            }
                        }}
                    >
                        <PostVideoItem post={postData} isPlus={isPlus} />
                    </div>
                </React.Fragment>
            );
        });
        return section;
    }

    const renderFriends = () => {
        let list = friendsTab === "following" ? following : followers;

        if (!list || list.length === 0) {
            return <div className="text-center w-100"><strong>No {friendsTab} yet.</strong></div>;
        }

        const totalPages = Math.ceil(list.length / FRIENDS_PER_PAGE);
        const start = (friendsPage - 1) * FRIENDS_PER_PAGE;
        const end = start + FRIENDS_PER_PAGE;
        const currentPageList = list.slice(start, end);

        return (<>
                <div className="pagination-controls text-center ml-2" style={{marginTop:"5px"}}> 
                    <button
                        className="btn btn-sm btn-outline-primary mx-1"
                        onClick={() => setFriendsPage(friendsPage - 1)} 
                        disabled={friendsPage === 1}
                    >
                        <i className="fas fa-chevron-left"></i>
                    </button> 
                    <span className="mx-2">Page {friendsPage} from {totalPages}</span> 
                    <button
                        className="btn btn-sm btn-outline-primary mx-1"
                        onClick={() => setFriendsPage(friendsPage + 1)}
                        disabled={friendsPage === totalPages}
                    >
                        <i className="fas fa-chevron-right"></i>
                    </button> 
                </div>
                <div className="row p-0 m-0 w-100">
                    {currentPageList.map((user, index) => {
                        let name = friendsTab === "following" ? user.following : user.follower;
                        return (
                            <div key={index} className="col-6 col-sm-4 col-md-3 col-lg-2 p-1 text-center">
                                <Link to={`/u/${name}`}>
                                    <img
                                        src={`https://steemitimages.com/u/${name}/avatar`}
                                        className="friend-avatar rounded-circle"
                                        style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                        alt="user"
                                    />
                                    <div className="mt-2">{name}</div>
                                </Link>
                            </div>
                        );
                    })}
                </div> 
        </>);
    }
    const renderCommunities = () => {
        let list = communities;

        if (!communities || communities.length === 0) {
            return <div className="text-center w-100"><strong>No communities yet.</strong></div>;
        }

        const totalPages = Math.ceil(list.length / COMMUNITIES_PER_PAGE);
        const start = (communitiesPage - 1) * COMMUNITIES_PER_PAGE;
        const end = start + COMMUNITIES_PER_PAGE;
        const currentPageList = list.slice(start, end);

        return (<>
                <div className="pagination-controls text-center ml-2" style={{marginTop:"5px"}}> 
                    <button
                        className="btn btn-sm btn-outline-primary mx-1"
                        onClick={() => setcommunitiesPage(communitiesPage - 1)} 
                        disabled={communitiesPage === 1}
                    >
                        <i className="fas fa-chevron-left"></i>
                    </button> 
                    <span className="mx-2">Page {communitiesPage} from {totalPages}</span> 
                    <button
                        className="btn btn-sm btn-outline-primary mx-1"
                        onClick={() => setcommunitiesPage(communitiesPage + 1)}
                        disabled={communitiesPage === totalPages}
                    >
                        <i className="fas fa-chevron-right"></i>
                    </button> 
                </div>
                <div className="row p-0 m-0 w-100">
                    {currentPageList.map((community, index) => {
                        let tag   = community[0];
                        let title = community[1];
                        let role  = community[2];
                        let label = community[3];
                        return (
                            <div key={index} className="col-6 col-sm-4 col-md-3 p-1 text-center">
                                <Link to={`/new/${tag}`}>
                                    <img
                                        src={`https://steemitimages.com/u/${tag}/avatar`}
                                        className="friend-avatar rounded-circle"
                                        style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                        alt="community"
                                    />
                                    <div className="mt-2">{title} <div className="text-muted d-inline-block">· {role}</div></div>
                                    {label && <div className="community-label shadow-hover">{label}</div>}
                                </Link>
                            </div>
                        );
                    })}
                </div> 
        </>);
    }
    const renderPlaylists = () => {
        let list = playlists;

        if (!playlists || playlists.length === 0) {
            return <div className="text-center w-100"><strong>No playlists yet.</strong></div>;
        }

        const totalPages = Math.ceil(list.length / PLAYLISTS_PER_PAGE);
        const start = (playlistsPage - 1) * PLAYLISTS_PER_PAGE;
        const end = start + PLAYLISTS_PER_PAGE;
        const currentPageList = list.slice(start, end);

        return (<>
                <div className="pagination-controls text-center ml-2" style={{marginTop:"5px"}}> 
                    <button
                        className="btn btn-sm btn-outline-primary mx-1"
                        onClick={() => setPlaylistsPage(playlistsPage - 1)} 
                        disabled={playlistsPage === 1}
                    >
                        <i className="fas fa-chevron-left"></i>
                    </button> 
                    <span className="mx-2">Page {playlistsPage} from {totalPages}</span> 
                    <button
                        className="btn btn-sm btn-outline-primary mx-1"
                        onClick={() => setPlaylistsPage(playlistsPage + 1)}
                        disabled={playlistsPage === totalPages}
                    >
                        <i className="fas fa-chevron-right"></i>
                    </button> 
                </div>
                <div className="row p-0 m-0 w-100">
                    {currentPageList.map((playlist, index) => { 
                        let items = playlist?.items?.length || 0;
                        return (
                            <div key={index} className="col-6 col-sm-4 col-md-3 p-1 text-center">
                                <div className={`card-stats card item-speem pd-0 m-0`}> 
                                    <div className="card-body p-0 m-0">
                                        <div className="thumbnail-container"> 
                                            <Link to={`/playlist/${playlist?.id}`} className="thumbnail-wrapper">
                                            <img src={playlist?.cover || "/assets/img/playlists.png"} alt={`Thumbnail`} className={`thumbnail object-contain`} loading='lazy' />
                                            <div className="thumbnail-overlay"></div>
                                            </Link>
                                            <span className="duration"><i className="fas fa-eye" /> {items} {items === 1 ? "video" : "videos"}</span>
                                        </div>
                                        <div className="details p-1">
                                        <div className='container-fluid mt-2'>
                                            <Row>
                                                {/* <div className="img-post-user">
                                                    <img className="user-post-logo" src={imageLink} alt="User Avatar" /> 
                                                </div> */}
                                                <div className="description-container">
                                                    <div className="title-row">
                                                    <Link to={`/playlist/${playlist?.id}`} className="title-link">
                                                        <h3 className="title">{playlist?.name}</h3>
                                                    </Link>
                                                    </div>
                                                    {/* <div className="playlist-description"> 
                                                        <span>{playlist?.description}</span> 
                                                    </div>  */}
                                                </div> 
                                            </Row>
                                        </div>
                                        </div>
                                    </div> 
                                    </div>
                            </div>
                        );
                    })}
                </div> 
        </>);
    }
 
    if (error) {
        console.log(error);
        toast({
            title: "Error",
            description: error,
            variant:"rose_red"
        });  
    }
    if (errorMessage) {
        console.log(errorMessage);
        toast({
            title: "Error",
            description: errorMessage,
            variant:"rose_red"
        }); 
    }

    return (
        <div className="user-settings mt-2 container-fluid"> 
        <SEO 
            title={(profileData.name || "") +" - Speak on Steem"}
            description={profileData.about}
            image={profileData.avatar}
            type="profile"
            author={username}
        />
            <div className="card-stats card item-speem mb-0">
                {userCover && userCover}
                <div className="card-body pb-0" style={{marginTop:(userCover)?"-100px":""}}>
                    {(isLoading && (!userData || Object.keys(userData).length === 0)) && (
                        <div className="row profile-container d-flex p-2">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-auto text-center text-sm-center text-md-left">
                                <div className="profile-image-container">
                                    <Skeleton circle={true} height={120} width={120} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-9 col-lg-auto text-center text-sm-center text-md-left">
                                <div className="d-inline-block">
                                    <Skeleton width={250} height={30} className="mb-2" />
                                </div>
                                <div className="mb-4">
                                    <Skeleton width={300} height={20} />
                                </div>
                                <div className="following-list mb-2">
                                     <Skeleton width={200} height={30} />
                                </div>
                                <div className="profile-about mb-1">
                                    <Skeleton width={400} height={20} />
                                </div>
                                <div className="mt-1">
                                    <Skeleton width={150} height={15} />
                                </div>
                            </div>
                        </div>
                    )}
                    {userData && Object.keys(userData).length > 0 && (
                        <>
                        {profileHeader}
                        
                        </>
                    )}
                    
                </div>
            </div>  
            <div className="p-0 mb-2">
                <div className="container-fluid p-0">
                    <div className="col-12 p-0">
                        <div className="menu-tabs">
                            <button className={`tab-button ${activeTab === 'videos' ? 'active' : ''}`} onClick={() => setActiveTab('videos')} title="Videos">
                                <i className="fas fa-play" /> <span className="d-none d-md-inline ml-1">Videos</span>
                            </button>
                            <button className={`tab-button ${activeTab === 'playlists' ? 'active' : ''}`} onClick={() => setActiveTab('playlists')} title="Playlists">
                                <span className="playlist-icon-wrap">
                                    <i className="fas fa-list" />
                                    <i className="fas fa-play small-play" />
                                </span> <span className="d-none d-md-inline ml-1">Playlists</span>
                            </button>
                            <button className={`tab-button ${activeTab === 'blog' ? 'active' : ''}`} onClick={() => setActiveTab('blog')} title="Blog">
                                <i className="fas fa-grip-vertical" /> <span className="d-none d-md-inline ml-1">Blog</span>
                            </button>
                            <button className={`tab-button ${activeTab === 'shared' ? 'active' : ''}`} onClick={() => setActiveTab('shared')} title="Shared">
                                <i className="fas fa-share" /> <span className="d-none d-md-inline ml-1">Shared</span>
                            </button>
                            <button className={`tab-button ${activeTab === 'comments' ? 'active' : ''}`} onClick={() => setActiveTab('comments')} title="Comments">
                                <i className="fas fa-comment" /> <span className="d-none d-md-inline ml-1">Comments</span>
                            </button>
                            <button className={`tab-button ${activeTab === 'friends' ? 'active' : ''}`} onClick={() => setActiveTab('friends')} title="Friends">
                                <i className="fas fa-user-plus" /> <span className="d-none d-md-inline ml-1">Friends</span>
                            </button> 
                            <button className={`tab-button ${activeTab === 'communities' ? 'active' : ''}`} onClick={() => setActiveTab('communities')} title="Communities">
                                <i className="fas fa-users" /> <span className="d-none d-md-inline ml-1">Communities</span>
                            </button> 
                        </div> 
                    </div>
                </div>
            </div>
            <div className="row p-0 m-0"> 
                {activeTab == "videos" && ( 
                    <div className="col-12">
                        Sort: <select className='videos-sort-input' name="videos-sort" id="videos-sort" value={videosSort} onChange={(e)=> {
                            setVideosSort(e.target.value);
                        }}>
                            <option value="recent">New</option>
                            <option value="top">Top</option>
                        </select>
                    </div> 
                )}
                {(() => {
                    let section;
                    switch (activeTab) {
                        case "friends":
                            section = (
                                <>
                                    <div className="category-bar">
                                        <button className={`category-button ${friendsTab == "following" ? `active`:``}`} onClick={() => setFriendsTab('following')}>Following</button>
                                        <button className={`category-button ${friendsTab == "followers" ? `active`:``}`} onClick={() => setFriendsTab('followers')}>Followers</button> 
                                    </div> 
                                    {renderFriends()}
                                </>
                            );
                            break; 
                        case "communities":
                            section = renderCommunities();
                            break;
                        case "playlists":
                            section = renderPlaylists();
                            break;
                        default:
                            section = renderPosts();
                            break;
                    }
                    return section;
                })()}
                {loadingMore && <div className='col-12 text-center color-orange'>Loading more videos...</div>} 
            </div>
        </div>
    );
};

// export default UserProfile;
